<style>

#titleCard {
  background-color: #1976d2;
  color: white;
}

#mainCard {
  width: 98%;
  margin: auto;
}

#insertButton {
  margin: 10px;
}

.category {
  font-size: 8px;
  color: #666;
}

.v-data-table-header__content {
  font-weight: bold;
}

.details_dialog {
  max-width: 60%;
}

.action_button {
  margin: 2px;
}

.searchbar_buttons {
  margin: 10px;
  min-width: 150px;
}

.status_chip {
  min-width: 85px;
}

</style>

<template>
  <v-card-title class="d-flex align-center pe-2">
    <v-row>
      <v-col cols="12" md="2" sm="12" class="align-self-center">
        <v-card
          title="Contenziosi"
          subtitle="e Revisioni"
          variant="tonal"
          id="titleCard"
        ></v-card>
      </v-col>
      <v-col cols="5" md="2" sm="5" class="align-self-center">
        <v-text-field
          v-model="search_filter"
          density="compact"
          prepend-inner-icon="mdi-magnify"
          variant="solo-filled"
          flat
          hide-details
          single-line
          clearable
          @click:clear="search_filter = null; this.litigations_load({page: 1})"
          @keydown.enter="litigations_load({page: 1})"
          ref="filterField"
          :placeholder=filterfield_helptext
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="1" sm="12" class="align-self-center">
        <v-select
        clearable
        @clear="search_status = null"
        v-model="search_status"
        density="compact"
        label="Stato"
        hide-details
        :items="status_options.map(t => t.value)"
        @update:model-value="litigations_load"
        ref="searchStatus"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1" sm="12" class="align-self-center">
        <v-select
        clearable
        v-model="search_invoiced"
        density="compact"
        label="Fatturata"
        hide-details
        :items="invoiced_options.map(t => t.value)"
        @update:model-value="litigations_load"
        ref="searchInvoiced"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1" sm="12" class="align-self-center">
        <v-select
        clearable
        v-model="search_in_charge_of"
        density="compact"
        label="In carico a"
        hide-details
        :items="in_charge_of_options.map(t => t.value)"
        @update:model-value="litigations_load"
        ref="searchInChargeOf"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1" sm="12" class="align-self-center">
        <v-select
        clearable
        v-model="search_type"
        density="compact"
        label="Tipo"
        hide-details
        :items="type_options.map(t => t.value)"
        @update:model-value="litigations_load"
        ref="searchType"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1" sm="12" class="align-self-center">
        <v-select
        clearable
        v-model="search_error_type"
        density="compact"
        label="Errore"
        hide-details
        :items="error_type_options.map(t => t.value)"
        @update:model-value="litigations_load"
        ref="searchErrorType"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1" sm="12" class="align-self-center">
        <v-btn 
          class="searchbar_buttons"
          prepend-icon="mdi-magnify"
          variant="tonal"
          @click="litigations_load"
        >
          Cerca
        </v-btn>
        <v-btn 
          class="searchbar_buttons"
          :disabled="load_results.length === 0"
          :color="load_results.length === 0 ? 'grey' : primary"
          prepend-icon="mdi-file-excel-outline" 
          variant="tonal"
          @click="exportToExcel(load_results.map(result => result.id))">
          Excel
        </v-btn>
      </v-col>
    </v-row>
  </v-card-title>

  <v-card id="mainCard">
    <v-btn 
    @click="insertLitigation()"
    icon="mdi-plus"
    variant="tonal"
    id="insertButton">
    </v-btn>

    <v-data-table-server
    v-model:items-per-page="items_per_page"
    :headers="headers.filter(header => header.value !== 'id')"  
    :items="load_results"
    :itemsLength="total_results"
    :loading="loading"
    :items-per-page-text="'Elementi per pagina: '"
    :page-text="`Da {0} a {1} di {2} elementi`"
    @update:options="litigations_load">
      <template v-slot:loading>
        <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td>
            <div style="display: flex; align-items: center;">
              <v-tooltip text="Dettagli">
                <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" class="action_button" variant="tonal" icon="mdi-eye" size="x-small" @click="loadLitigationDetails(item)"></v-btn>
                </template>
              </v-tooltip>
              <v-tooltip text="Notifica">
                <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" class="action_button" variant="tonal" icon="mdi-send" size="x-small" @click="notifyLitigation(item)"></v-btn>
                </template>
              </v-tooltip>
            </div>
          </td>
          <td v-for="header in headers.slice(1).filter(header => header.value !== 'id')" :key="header.value">
            <template v-if="['status'].includes(header.value)">
              <v-chip 
                class="status_chip"
                :color="item.status === 'Chiusa' ? 'grey' : 'orange'"
                :text="item.status"
                :prepend-icon="item.status === 'Chiusa' ? 'mdi-check-circle-outline' : 'mdi-alert-outline'"
              ></v-chip>
            </template>
            <template v-else-if="['type'].includes(header.value)">
              {{ item.type.name }}<br>
              <span class="category">({{ item.type.category }})</span>
            </template>
            <template v-else-if="['error_type'].includes(header.value)">
              {{ item.error_type.name }}<br>
            </template>
            <template v-else>
              {{ item[header.value] }}
            </template>
          </td>
        </tr>
      </template>
    </v-data-table-server>
  </v-card>

  <insertDialog ref="insertDialog" :type_options="type_options" :error_type_options="error_type_options" @insert-completed="litigations_load(1, this.items_per_page, ['id'])" />
  <detailsDialog 
    ref="detailsDialog" 
    :type_options="type_options" 
    :error_type_options="error_type_options" 
    @delete-completed="litigations_load(1, this.items_per_page, ['id'])"
    @update-completed="litigations_load(1, this.items_per_page, ['id'])"/>
  <confirmErrorNotificationDialog ref="confirmErrorNotificationDialog" />
  
</template>

<script LitigationsTableSetup>
  import axios from 'axios';
  import _ from 'lodash';
  import insertDialog from './InsertDialog.vue';
  import detailsDialog from './DetailsDialog.vue';
  import confirmErrorNotificationDialog from './ConfirmErrorNotificationDialog.vue';

  export default {
    created() {
      this.loadManifest()
    },
    components: {
      insertDialog,
      detailsDialog,
      confirmErrorNotificationDialog
    },
    data() {
      return {
        headers: [{ title: 'Azioni', value: '', sortable: false}],
        headers_details_additional: [
          { title: 'Dichiarazioni', value: 'declarations', sortable: false},
        ],
        export_columns: [
          { label: 'Id', field: 'id'},
          { label: 'Numero', field: 'number'},
          { label: 'Data Creazione', field: 'creation_date'},
          { label: 'Stato', field: 'status'},
          { title: 'Protocollo', field: 'protocol'},
          { title: 'Data Notifica', field: 'notification_date'},
          { title: 'Data Scadenza', field: 'expiration_date'},
        ],
        loading: false,
        search_filter: null,
        search_status: null,
        search_invoiced: null,
        search_in_charge_of: null,
        search_type: null,
        search_error_type: null,
        items_per_page: 10,
        load_results: [],
        table_columns: [],
        total_results: 0,
        selected_id: null,
        status_options: [],
        invoiced_options: [],
        in_charge_of_options: [],
        type_options: [],
        error_type_options: [],
        filterfield_helptext: null        
      }
    },
    watch: {
      table_columns(newValue) {
        const newHeaders = newValue.map(c => ({
          title: c.label,
          value: c.field_name,
          sortable: c.orderable ?? false,
        }))
        this.headers.push(...newHeaders)
      }
    },
    name: 'litigationsGrid',
    methods: {
      async litigations_load(...args) {
        const params = args[0] === null ? {} : args[0];
        const { page = 1, itemsPerPage = 10, sortBy = [] } = params;
        try {
          this.loading = true
          setTimeout(() => {
            this.loading = false
          }, 60000)

          let ordering_by = 'id'

          if (sortBy.length) {
            const sortKey = sortBy[0].key
            const sortOrder = sortBy[0].order
            if (sortOrder === 'asc') {
              ordering_by = `${sortKey}`
            } else {
              ordering_by = `-${sortKey}`
            }
          }

          const statusFilter = this.search_status != null ? `&status=${this.search_status}` : ''
          const litigationFilter = this.search_filter ? `&litigation=${encodeURIComponent(this.search_filter)}` : ''
          const invoicedFilter = this.search_invoiced === 'Si' ? '&invoiced=1' : this.search_invoiced === 'No' ? '&invoiced=0' : ''
          const inChargeOfFilter = this.search_in_charge_of ? `&in_charge_of=${this.search_in_charge_of}` : ''
          const typeFilter = this.search_type ? `&type=${this.type_options.find(t => t.value === this.search_type)?.key}` : ''
          const errorTypeFilter = this.search_error_type ? `&error_type=${this.error_type_options.find(t => t.value === this.search_error_type)?.key}` : ''

          let queryString = `/api/litigations/?page=${page}&page_size=${itemsPerPage}&ordering=${ordering_by}`
          queryString += statusFilter 
          queryString += litigationFilter 
          queryString += invoicedFilter 
          queryString += inChargeOfFilter 
          queryString += typeFilter 
          queryString += errorTypeFilter

          const response = await axios.get(queryString);

          if(itemsPerPage === -1) {
            this.items_per_page = response.data.count
          } else {
            this.items_per_page = itemsPerPage
          }
          this.load_results = response.data.results
          this.total_results = response.data.count
        } catch(error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      },
      async loadLitigationDetails(selected_item) {
        try {

          const response = await axios.get(`/api/litigations/${selected_item.id}/`);
          this.$refs.detailsDialog.selected_item = JSON.parse(JSON.stringify(response.data));
          this.$refs.detailsDialog.formValues = _.cloneDeep(this.$refs.detailsDialog.selected_item);

          this.$refs.detailsDialog.headers = this.headers;
          this.$refs.detailsDialog.headers_details_additional = this.headers_details_additional;
          this.$refs.detailsDialog.show = true;
        } catch(error) {
          console.error(error);
        }
      },
      async loadManifest() {
        try {

          const response = await axios.get('/api/litigations/manifest/'); 

          this.$refs.filterField.placeholder = response.data.main_table.table_filters.find(filter => filter.field_name === 'litigation').help_text;
          this.table_columns = response.data.main_table.table_columns;

          this.status_options = Object.entries(response.data.registries.status).map(([key, value]) => ({key, value}));
          this.invoiced_options = Object.entries(response.data.registries.invoiced).map(([key, value]) => ({key, value}));
          this.in_charge_of_options = Object.entries(response.data.registries.in_charge_of).map(([key, value]) => ({key, value}));
          this.type_options = Object.entries(response.data.registries.type).map(([key, value]) => ({key, value})).sort((a, b) => a.value.localeCompare(b.value));
          this.error_type_options = Object.entries(response.data.registries.error_type).map(([key, value]) => ({key, value})).sort((a, b) => a.value.localeCompare(b.value));   
          const litigation_filter = response.data.main_table.table_filters.find(f => f.field_name === 'litigation'); 
          this.filterfield_helptext =litigation_filter ? litigation_filter.help_text : '';

        } catch (error) {
          console.error('Error fetching manifest:', error);
        }
      },
      formatDateBeforeInsert(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      insertLitigation() {
        this.$refs.insertDialog.headers = this.headers;
        this.$refs.insertDialog.headers_details_additional = this.headers_details_additional;
        this.$refs.insertDialog.show = true;
      },
      async notifyLitigation(selected_item) {
        try {

          const response = await axios.get(`/api/litigations/${selected_item.id}/`);

          this.$refs.confirmErrorNotificationDialog.selected_item = JSON.parse(JSON.stringify(response.data));
          this.$refs.confirmErrorNotificationDialog.show = true;
        } catch(error) {
          console.error(error);
        }
      },
      exportToExcel(ids_list) {
        console.log('esportazione in excel degli id: ', ids_list)
        axios({
          url: `/api/litigations/export_xls_litigations/`,

          method: 'POST',
          data: { list_of_id: ids_list },
          responseType: 'blob', // important
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const now = new Date();
          const filename = `${now.getFullYear()}${('0' + (now.getMonth() + 1)).slice(-2)}${('0' + now.getDate()).slice(-2)}_${('0' + now.getHours()).slice(-2)}${('0' + now.getMinutes()).slice(-2)}${('0' + now.getSeconds()).slice(-2)}_litigations.xlsx`;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        });
      },
    }
  };
</script>
